import type { OrderEvent } from "@@/shared/orders/order-events/events/_order-event";
import type { OrderChangeRefundRequestedEvent } from "@@/shared/orders/order-events/events/order-change-refund-requested.event";
import type { OrderFullRefundRequestedEvent } from "@@/shared/orders/order-events/events/order-full-refund-requested.event";
import type { OrderPartialRefundRequestedEvent } from "@@/shared/orders/order-events/events/order-partial-refund-requested.event";

const isOrderRefundRequestEvent = (
    event: OrderEvent,
): event is
    | OrderFullRefundRequestedEvent
    | OrderPartialRefundRequestedEvent
    | OrderChangeRefundRequestedEvent => {
    return (
        event.type === "FULL_REFUND_REQUESTED" ||
        event.type === "PARTIAL_REFUND_REQUESTED" ||
        event.type === "ORDER_CHANGE_REFUND_REQUESTED"
    );
};

export { isOrderRefundRequestEvent };
